module.exports = __webpack_public_path__ + "static/53-future-of-work-ai-is-reshaping-managers-traditional-role-c4844dff5aa842a8677103aa6409d594.png";